<script>
import VueQr from 'vue-qr'
import axios from 'axios'
import { authComputed, authMethods } from '@state/helpers'
import { userService } from '@/src/services/UserService'
import OtpInput from './otp-input.vue'
import Form from '@classes/Form'

export default {
  page: {
    title: 'Qrgoogle',
    meta: [{ name: 'description', content: 'The Qrgoogle page.' }],
  },
  components: {
    VueQr,
    OtpInput,
  },
  props: {
    uuid: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      tryingToCancel: false,
      authError: null,
      showCode: false,
      userForm: new Form({
        first_name: '',
        last_name: '',
        gender: '',
        sex: '',
        credential: '',
        dob: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone_number: '',
        imperial_units: '',
        has_mfa_enabled: false,
      }),
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    tryToCancel() {
      this.tryingToCancel = true
      axios
        .delete(`/api/v1/mfa/${this.uuid}`, {
          device_type: 'google',
        })
        .then(() => {
          this.removeMfaDevice({ id: this.uuid })
          this.tryingToCancel = false
          this.$router.push({ name: 'safehaven-profile' })
        })
        .catch((error) => {
          console.warn(error)
        })
    },
    async tryToContinue() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      userData.has_mfa_enabled = true
      this.userForm.first_name = userData.first_name
      this.userForm.last_name = userData.last_name
      this.userForm.gender = userData.gender.key
      this.userForm.sex = userData.sex.key
      this.userForm.credential = userData.credential
      this.userForm.dob = userData.dob
      this.userForm.email = userData.email
      this.userForm.address = userData.address
      this.userForm.city = userData.city
      this.userForm.state = null
      this.userForm.zip = userData.zip_code
      this.userForm.phone_number = userData.phone_number
      this.userForm.imperial_units = userData.imperial_units
      this.userForm.has_mfa_enabled = userData.has_mfa_enabled
      const response = await userService.update(
        this.serializedUser.user_id,
        this.userForm.data()
      )
      if (response.status === 200)
        this.$router.push({ name: 'safehaven-profile' })
      // todo: same as hotp register, backend shouldnt require 2fa enabled to verify code
    },
    async verifyCode(code) {
      try {
        // 1. Make sure verification code is ok
        const verifyResponse = await axios.post('/api/v1/verify/', {
          code: code,
        })

        if (verifyResponse.status === 200) {
          // 2. Enable mfa
          const response = await userService.update(
            this.serializedUser.user_id,
            {
              has_mfa_enabled: true,
            }
          )
          if (response.status === 200)
            this.$router.push({ name: 'settings.security' })
        }
      } catch (error) {
        this.authError = error
        throw new Error(`Problem handling something: ${error}`)
      }
    },
  },
}
</script>

<template>
  <v-container fluid class="fill-height">
    <v-card class="mx-auto pa-4">
      <v-container>
        <v-row class="justify-center mb-5">
          <h3>2FA Setup</h3>
        </v-row>
        <v-row class="justify-center">
          <h4>Scan the QR code:</h4>
        </v-row>
        <v-row class="justify-center">
          <VueQr :text="value" :size="200"></VueQr>
        </v-row>
        <v-row class="justify-center">
          <small>Don't close or refresh this window</small>
        </v-row>
        <div class="row mt-4">
          <div class="col-md-6">
            <v-btn
              color="primary"
              text
              :loading="tryingToCancel"
              @click="tryToCancel"
            >
              Cancel
            </v-btn>
          </div>
          <div class="col-md-6">
            <v-btn color="primary" @click="tryToContinue"> Continue </v-btn>
          </div>
        </div>
        <div v-if="showCode" class="mt-5">
          <p>Please enter your verification code to proceed</p>
          <v-row justify="center">
            <OtpInput
              :class="authError ? $style.invalid : ''"
              @input="verifyCode"
            ></OtpInput>
          </v-row>
        </div>
      </v-container>
    </v-card>
    <p v-if="authError" class="mt-4 text-center">
      There was an error logging in to your account.
      <br />
      <strong>{{ authError.response.data }}</strong>
    </p>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.invalid {
  /* also need animation and -moz-animation */
  -webkit-animation: shake 0.5s linear;
}

/* also need keyframes and -moz-keyframes */
@-webkit-keyframes shake {
  8%,
  41% {
    -webkit-transform: translateX(-10px);
  }
  25%,
  58% {
    -webkit-transform: translateX(10px);
  }
  75% {
    -webkit-transform: translateX(-5px);
  }
  92% {
    -webkit-transform: translateX(5px);
  }
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
}
</style>
